// import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import Immutable from 'immutable';

import albumDuck from './albumDuck';
import announcementDuck from './announcementDuck';
import contactInfoDuck from './contactInfoDuck';
import customContentDuck from './customContentDuck';
import documentDuck from './documentDuck';
import organizationDuck from './organizationDuck';
import pageDuck from './pageDuck';
import railsContextDuck from './railsContextDuck';
import registrationDuck from './registrationDuck';
import scheduleDuck from './scheduleDuck';
import slideshowDuck from './slideshowDuck';
import sponsorDuck from './sponsorDuck';
import checkrDuck from './checkrDuck';
import notificationBadgeDuck from '../../bundles/OrganizationConfig/redux/modules/notificationBadgeDuck';
import appDuck from './appDuck';
import jsonApiDuck from './jsonApiDuck';
import jsonApiDuckV2, {
  initialState as jsonApiV2InitialState,
} from './jsonApiDuckV2';
import { sendAnnouncementSlice } from 'appDir/components/Public/Announcements/Show/Edit/Send/SendAnnouncementButton/SendAnnouncementDialog/sendAnnouncementSlice';
import { combineReducers } from '@reduxjs/toolkit';

export const $$initialState = Immutable.Map({
  $$albumStore: albumDuck.initialState,
  $$announcementStore: announcementDuck.initialState,
  $$checkrStore: checkrDuck.initialState,
  $$contactInfoStore: contactInfoDuck.initialState,
  $$customContentStore: customContentDuck.initialState,
  $$documentStore: documentDuck.initialState,
  $$notificationBadgeStore: notificationBadgeDuck.initialState,
  $$organizationStore: organizationDuck.initialState,
  $$pageStore: pageDuck.initialState,
  $$railsContextStore: railsContextDuck.initialState,
  $$registrationStore: registrationDuck.initialState,
  $$scheduleStore: scheduleDuck.initialState,
  $$slideshowStore: slideshowDuck.initialState,
  $$sponsorStore: sponsorDuck.initialState,
  appStore: appDuck.initialState,
  jsonApiStore: jsonApiDuck.initialState,
  jsonApiStoreV2: jsonApiV2InitialState,
});

const reducers = {
  sendAnnouncementSlice: sendAnnouncementSlice.reducer,
  $$albumStore: albumDuck.reducer,
  $$announcementStore: announcementDuck.reducer,
  $$checkrStore: checkrDuck.reducer,
  $$contactInfoStore: contactInfoDuck.reducer,
  $$customContentStore: customContentDuck.reducer,
  $$documentStore: documentDuck.reducer,
  $$notificationBadgeStore: notificationBadgeDuck.reducer,
  $$organizationStore: organizationDuck.reducer,
  $$pageStore: pageDuck.reducer,
  $$railsContextStore: railsContextDuck.reducer,
  $$registrationStore: registrationDuck.reducer,
  $$scheduleStore: scheduleDuck.reducer,
  $$sponsorStore: sponsorDuck.reducer,
  $$slideshowStore: slideshowDuck.reducer,
  appStore: appDuck.reducer,
  jsonApiStore: jsonApiDuck.reducer,
  jsonApiStoreV2: jsonApiDuckV2,
};

export default history =>
  combineReducers({
    ...reducers,
    router: connectRouter(history),
  });
